import { useLocalSearchParams, router } from 'expo-router';
import { ConversationScreen } from '@/components/domain/messages/ConversationScreen';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';
import { MessagesScreen } from '@/components/domain/messages/MessagesScreen';

export default function MessageConversationSharedRoute() {
  const { id } = useLocalSearchParams();
  const isLargeScreen = useIsLargeScreen();
  const messageId = parseInt(id as string, 10);

  if (isNaN(messageId)) {
    router.navigate('/messages/inbox');
  }

  return isLargeScreen ? (
    <MessagesScreen initialMessageType="inbox" messageId={messageId} />
  ) : (
    <ConversationScreen messageId={messageId} />
  );
}
